var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOutSqureLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 15.9999L2.27607 15.6876L2.02619 15.9999L2.27607 16.3123L2.6665 15.9999ZM14.6665 16.4999C14.9426 16.4999 15.1665 16.2761 15.1665 15.9999C15.1665 15.7238 14.9426 15.4999 14.6665 15.4999V16.4999ZM7.6094 9.0209L2.27607 15.6876L3.05694 16.3123L8.39027 9.6456L7.6094 9.0209ZM2.27607 16.3123L7.6094 22.9789L8.39027 22.3542L3.05694 15.6876L2.27607 16.3123ZM2.6665 16.4999H14.6665V15.4999H2.6665V16.4999Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 10.8427V8.72192C13.3335 7.10358 13.3335 6.29441 13.8075 5.73492C14.2814 5.17543 15.0796 5.0424 16.6759 4.77635L22.3471 3.83115C25.5902 3.29063 27.2117 3.02037 28.2726 3.91907C29.3335 4.81777 29.3335 6.46168 29.3335 9.74951V22.2507C29.3335 25.5385 29.3335 27.1824 28.2726 28.0811C27.2117 28.9798 25.5902 28.7095 22.3471 28.169L16.6759 27.2238C15.0796 26.9578 14.2814 26.8247 13.8075 26.2652C13.3335 25.7058 13.3335 24.8966 13.3335 23.2782V21.4214",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutSqureLight);
export default __webpack_public_path__ + "static/media/Sign_out_squre_light.5c2ebab968b2b3d82a547d401fa711ce.svg";
export { ForwardRef as ReactComponent };